export const DOCS_BASE_URL = "https://ambitious-glacier-003879510.1.azurestaticapps.net";
